import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../store'

import { CurrentSubView, Mode, Routes } from '../../models/enums'

import HomeView from '../Views/HomeView'
import NewsView from '../Views/NewsView'
import WarningBeforeNewsView from '../Views/WarningBeforeNewsView'

interface RetorikRouterProps {
  externalComponents?: Array<{ name: string; component: JSX.Element }>
}

const RetorikRouter = (props: RetorikRouterProps): JSX.Element => {
  const dispatch = useDispatch()
  const isUsedOnBorne = useSelector((state: RootState) => state.retorikReducer.configuration.isUsedOnBorne)
  const mode = useSelector((state: RootState) => state.speechReducer.mode)
  const route = useSelector((state: RootState) => state.viewReducer.route)
  const lastBotEvent = useSelector((state: RootState) => state.activityReducer.lastBotEventActivity)

  useEffect(() => {
    if (lastBotEvent) {
      switch (lastBotEvent.name) {
        case 'news.ShowFlashInfo':
          dispatch(storeActions.view.setRoute(Routes.News))
          break
        case 'weather.ShowWeather':
          dispatch(storeActions.utils.setCurrentSubView(CurrentSubView.weather))
          break
        default:
          break
      }
    }
  }, [lastBotEvent])

  return (
    <React.Fragment>
      {route === Routes.Home ? <HomeView {...props} /> : <React.Fragment />}
      {route === Routes.News ? mode === Mode.vocal || !!isUsedOnBorne ? <NewsView /> : <WarningBeforeNewsView /> : <React.Fragment />}
    </React.Fragment>
  )
}

export default RetorikRouter
